import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  fetchClients,
  fetchClientsReservations,
  createClient,
  deleteClient,
  updateClient
} from '../../services/clients'
import { toast } from 'react-toastify';

export const getClients = createAsyncThunk(
  'clients/fetchClients',
  async (thunkAPI) => {
    try {
      const res = await fetchClients()
      return res.data
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  },
)

export const addClient = createAsyncThunk(
  'clients/addClient',
  async (data,thunkAPI) => {
    try {

      const res = await toast.promise(
        createClient(data).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se registró el cliente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)


export const removeClient = createAsyncThunk(
  'clients/removeClient',
  async (id,thunkAPI) => {
    try {
      await toast.promise(
        deleteClient(id).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se eliminó correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );
      return id
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const editClient = createAsyncThunk(
  'clients/editClient',
  async ({id,...client},thunkAPI) => {
    try {
      const res = await toast.promise(
        updateClient(id, client).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se actualizó correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );
      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)


export const getClientsReservations = createAsyncThunk(
  'clients/fetchClientsReservations',
  async (thunkAPI) => {
    try {
      const res = await fetchClientsReservations()
      return res.data
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  },
)
